import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../../Img';
import ChatWithRallyButton from './ChatWithRallyButton';
import {
    PlayersNavItemV2,
    EventsNavItemV2,
    ClubsNavItemV2,
    CollegesNavItemsV2,
    HighSchoolsNavItemsV2,
    GlobalSearchTennisNavItemsV2,
    GlobalSearchPickleballNavItemsV2,
} from './GlobalSearchNavItemDictionary';
import GlobalSearchNavItem from './GlobalSearchNavItem';

import styles from './GlobalSearchNavigation.scss';

const GlobalSearchNavItemsV2 = (props) => {
    const {
        onFilterClick,
        onTeamLeagueClick,
        onUpdateSportType,
        onEventsClick,
        onChatWithAceClick,
        canAccessChatWithAce,
    } = props;

    const handleOnClick = (navItem) => {
        const { filterType, sportType, entityType } = navItem;
        if (navItem.isLeagues) {
            onTeamLeagueClick(filterType);
        } else if (navItem.filterType === 'events') {
            onEventsClick(sportType, entityType);
        } else {
            onFilterClick(filterType);
        }
        onUpdateSportType(sportType, entityType);
    };

    return (
        <div className={styles.globalNavItems}>
            {canAccessChatWithAce && (
                <ChatWithRallyButton onClick={onChatWithAceClick} />
            )}
            <div className={styles.allPlayersNavItem}>
                <GlobalSearchNavItem
                    label={PlayersNavItemV2.label}
                    entityType={PlayersNavItemV2.entityType}
                    testId={PlayersNavItemV2.testId}
                    onClick={() => handleOnClick(PlayersNavItemV2)}
                />
                <GlobalSearchNavItem
                    label={EventsNavItemV2.label}
                    entityType={EventsNavItemV2.entityType}
                    testId={EventsNavItemV2.testId}
                    onClick={() => handleOnClick(EventsNavItemV2)}
                />
                <GlobalSearchNavItem
                    label={ClubsNavItemV2.label}
                    entityType={ClubsNavItemV2.entityType}
                    testId={ClubsNavItemV2.testId}
                    onClick={() => handleOnClick(ClubsNavItemV2)}
                />
                <GlobalSearchNavItem
                    label={CollegesNavItemsV2.label}
                    entityType={CollegesNavItemsV2.entityType}
                    testId={CollegesNavItemsV2.testId}
                    onClick={() => handleOnClick(CollegesNavItemsV2)}
                />
                <GlobalSearchNavItem
                    label={HighSchoolsNavItemsV2.label}
                    entityType={HighSchoolsNavItemsV2.entityType}
                    testId={HighSchoolsNavItemsV2.testId}
                    onClick={() => handleOnClick(HighSchoolsNavItemsV2)}
                />
            </div>
            <div className={styles.sportNavItemsContainer}>
                <div className={styles.navItems}>
                    <div className={styles.menuHeader}>
                        <Img
                            src="/img/tennis-icon.svg"
                            alt="search menu tennis icon"
                        />
                        <p>Tennis</p>
                    </div>
                    {GlobalSearchTennisNavItemsV2.map((item) => {
                        const { label, entityType, testId } = item;
                        return (
                            <GlobalSearchNavItem
                                key={label}
                                label={label}
                                entityType={entityType}
                                testId={testId}
                                onClick={() => handleOnClick(item)}
                            />
                        );
                    })}
                </div>
                <div className={styles.navItems}>
                    <div className={styles.menuHeader}>
                        <Img
                            src="/img/pickleball-icon.svg"
                            alt="search menu pickleball icon"
                        />
                        <p>Pickleball</p>
                    </div>
                    {GlobalSearchPickleballNavItemsV2.map((item) => {
                        const { label, entityType, testId } = item;
                        return (
                            <GlobalSearchNavItem
                                key={label}
                                label={label}
                                entityType={entityType}
                                testId={testId}
                                onClick={() => handleOnClick(item)}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

GlobalSearchNavItemsV2.propTypes = {
    onFilterClick: PropTypes.func.isRequired,
    onEventsClick: PropTypes.func.isRequired,
    onTeamLeagueClick: PropTypes.func.isRequired,
    onUpdateSportType: PropTypes.func.isRequired,
    onChatWithAceClick: PropTypes.func.isRequired,
    canAccessChatWithAce: PropTypes.bool.isRequired,
};

export default GlobalSearchNavItemsV2;
